export enum ReceiptValidationAction {
    Store,
}
